export function formatPriceValue(decimalPlaces: number, value: number, currency?: string) {
  try {
    return new Intl.NumberFormat('en-US', {
      currency,
      style: currency ? 'currency' : undefined,
      minimumFractionDigits: decimalPlaces,
      maximumFractionDigits: decimalPlaces
    }).format(value);
  } catch {
    return new Intl.NumberFormat('en-US', {
      minimumFractionDigits: decimalPlaces,
      maximumFractionDigits: decimalPlaces
    }).format(value);
  }
}
